var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.application ? _c('div', {
    staticClass: "board-container"
  }, [_vm.application.program ? _c('view-program', {
    attrs: {
      "program": _vm.application.program
    }
  }) : _vm._e(), _vm.application ? _c('view-application', {
    attrs: {
      "application": _vm.application
    }
  }) : _vm._e(), _c('div', {
    staticClass: "board-buttons"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('a', {
    staticClass: "button button--border",
    on: {
      "click": _vm.list
    }
  }, [_c('span', [_vm._v("리스트")])])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }